import { FormattedProps } from './types';
import { EngagementUnit } from '../../shared/types';
import { Link, PropsFormatterUtils, TitleHtmlTag } from 'shared/types';
import { BlockOneshopUnauthenticatedRenewalSummary } from 'shared/api/client';

export default function propsFormatter(
  content: BlockOneshopUnauthenticatedRenewalSummary['content'],
  { getLinkHrefWithAuthentication }: PropsFormatterUtils
): FormattedProps {
  const minorProductsEngagementUnit: Record<string, EngagementUnit> = {};
  content.minorProducts.forEach(minor => {
    if (minor.productId && minor.engagementUnit) {
      minorProductsEngagementUnit[minor.productId] =
        EngagementUnit[minor.engagementUnit];
    }
  });

  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    productPriceLabel: content.productPriceLabel,
    renewalDateLabel: content.renewalDateLabel,
    majorProduct: {
      id: content.product?.productId,
      engagementUnit: content.product?.engagementUnit
        ? EngagementUnit[content.product.engagementUnit]
        : null
    },
    minorProductsTitle: {
      label: content.minorProductsTitle.label ?? '',
      htmlTag: content.minorProductsTitle.htmlTag
        ? (content.minorProductsTitle.htmlTag as TitleHtmlTag)
        : undefined
    },
    minorProductsEngagementUnit,
    totalLabel: content.totalLabel,
    submitButton: {
      label: content.submitButton.label ?? '',
      link: getLinkHrefWithAuthentication(
        content.submitButton.link ? (content.submitButton.link as Link) : null
      )
    },
    cancelButtonLabel: content.cancelButton.label ?? '',
    apiPostRenewalOfferSummary: {
      method: content.apis.crm_management_acts_qrcode_summary?.method ?? 'POST',
      url: content.apis.crm_management_acts_qrcode_summary?.url ?? ''
    }
  };
}
